import { Insights } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { FormattedMessage } from 'react-intl';
import { useSetRecoilState } from 'recoil';
import { WorkflowTypes, workflowModalState } from '~/state/atoms/viewerAtoms';
import StructureSetSelection from './StructureSetSelection';

export default function EmptyStructureSet() {
    const setWorkflowModalState = useSetRecoilState(workflowModalState);

    return (
        <Box display="flex" flexDirection="column" gap={1} mt={0.5}>
            <Typography variant="body2" fontSize={13}>
                No structure set selected
            </Typography>
            <Typography variant="body2" fontSize={13}>
                You can load structures or use auto segmentation to generate
                structures.
            </Typography>
            <Box>
                <Button
                    fullWidth
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    variant="contained"
                    size="small"
                    onClick={() => {
                        setWorkflowModalState({
                            page: WorkflowTypes.CONTOUR,
                            open: true,
                        });
                    }}
                    sx={{
                        textTransform: 'capitalize',
                        pl: 2,
                        fontSize: 12,
                    }}
                    data-testid="generate-contours-button"
                >
                    <Insights
                        sx={{
                            position: 'absolute',
                            left: 8,
                            marginRight: 1,
                            fontSize: 16,
                        }}
                    />

                    <FormattedMessage id="generateContours" />
                </Button>
                <StructureSetSelection />
            </Box>
        </Box>
    );
}
